<!-- 企业级-无人仓业务-预约记录 -->
<template>
  <div class="mainArea CAppointmentRecord">
      
        <div class="searchDiv mt20">
          <div>
            <div class="dib mb10"><el-input placeholder="请输入预约订单号" v-model="keyword.order_id" clearable></el-input></div>
            <!-- <div class="dib mb10"><el-input placeholder="请输入预约人姓名" v-model="keyword.name" clearable></el-input></div> -->
            <div class="dib mb10"><el-input placeholder="请输入预约人手机号码" v-model="keyword.phone" clearable></el-input></div>
            <div class="dib mb10">
              <el-select v-model="keyword.type" clearable placeholder="请选择订单类型">
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="getAppointment(1)">搜索</el-button>
          </div>
        </div>
        <el-button type="primary" class="mb20 mt20" @click="openAdd">添加</el-button>
        <div class="tabList">
          <el-table :data="recordList" style="width: 100%" v-loading="tableLoading">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table :data="props.row.signData" style="width: 100%" row-class-name="bgTable" header-cell-class-name="bgTable">
                  <el-table-column type="index" label="序号"></el-table-column>
                  <el-table-column prop="sign" label="标识号"></el-table-column>
                  <el-table-column prop="rfid" label="RFID"></el-table-column>
                  <el-table-column prop="packageno" label="LPN"></el-table-column>
                  <el-table-column prop="locator" label="位置"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="boundOrder" label="订单号"></el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.order_state=='7'">预约入库</span>
                <span v-if="scope.row.order_state=='50'">预约出库</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号码"></el-table-column>
            <el-table-column prop="location" label="子库"></el-table-column>
            <el-table-column prop="open_password" label="开门密码"></el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>page">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      <!--添加预约-->
      <el-dialog title="添加预约" :visible.sync="addAppointDio" width="600px">
        <div class="contDio">
          <el-form ref="form" :rules="rules" :model="addform" label-width="90px">
            <el-form-item label="预约类型:" prop="type">
              <el-select v-model="addform.type" placeholder="请选择预约类型">
                <el-option
                  v-for="item in typeList2"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号码:" prop="phone">
              <el-input placeholder="请输入手机号码" v-model="addform.phone"></el-input>
            </el-form-item>
            <el-form-item label="子库:" prop="original_data">
              <el-select v-model="addform.original_data" placeholder="请选择子库">
                <el-option
                  v-for="item in subList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="table">
            <el-table :data="rfidList" style="width: 100%">
              <el-table-column label="RFID">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.rfidId" size="small"></el-input>
                </template>
              </el-table-column>
              <!-- <el-table-column label="LPN">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.lpnNo" size="small"></el-input>
                </template>
              </el-table-column> -->
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.locator" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.$index ==rfidList.length-1" @click="addList">添加</el-button>
                  <el-button type="text" v-if="rfidList.length > 1" @click="delList(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitAdd('form')">确定</el-button>
          <el-button @click="addAppointDio = false">取消</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import { unmanApi } from "../../../../static/js/api.js"

  export default {
    name: 'CAppointmentRecord',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          order_id:'',//订单号
          name:'',//姓名
          phone:'',//手机号
          type:'',//类型
        },

        typeList:[{
          id:'7',
          name:'预约入库'
        },{
          id:'50',
          name:'预约出库'
        }],

        typeList2:[{
          id:'1',
          name:'预约入库'
        },{
          id:'2',
          name:'预约出库'
        }],

        recordList:[],
        tableLoading:false,

        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        addAppointDio:false,//添加预约弹窗
        addform:{
          type:'',
          phone:'',
          original_data:'',
        },
        subList:[],//子库列表
        rfidList:[{
          rfidId:'',
          // lpnNo:'',
          locator:'',
        }],

        rules:{
          type:[
            { required: true, message: '请选择类型', trigger: 'blur' },
          ],
          phone:[
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,message:'请输入正确的手机号'}
          ],
          original_data:[
            { required: true, message: '请选择子库', trigger: 'blur' },
          ],
        },
      }
    },
    mounted(){
    },
    created: async function () {
      this.getAppointment()
    },
    methods: {
      //删除rfid列表
      delList(index){
        this.rfidList.splice(index,1)
      },
      //添加rfid列表
      addList(){
        const obj = {
          rfidId:'',
          // lpnNo:'',
          locator:'',
        }
        this.rfidList.push(obj)
      },
      submitAdd(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(that.rfidList[0].rfidId != '' && that.rfidList[0].locator != ''){
            // if(that.rfidList[0].rfidId != '' && that.rfidList[0].lpnNo != '' && that.rfidList[0].locator != ''){
              that.addAppointment()
            }else{
              showToast('表格列表不能为空,请填入信息！')
            }
            
          } else {
            return false;
          }
        });
      },
      //添加预约出入库
      async addAppointment(){
        let that = this;
        const data = {
          'type':that.addform.type,
          'accountNo': that.addform.phone,//手机号
          'locationCode': that.addform.original_data,//子库
          'unmannedWarehouseVO': that.rfidList,//rfid列表
        }
        let res = await unmanApi.addAppointment(data)
        if(res.meta.code == 200){
          that.addAppointDio = false
          that.getAppointment(1)
          showToast('添加成功！')
          that.rfidList = [{
            rfidId:'',
            // lpnNo:'',
            locator:'',
          }]
          that.addform={
            type:'',
            phone:'',
            original_data:'',
          }
        }else{
          showToast(res.meta.message)
        }
      },
      //打开添加预约弹窗
      openAdd(){
        this.getLocationList()
        this.addAppointDio = true
      },
      //获取子库列表
      async getLocationList(curr,limits){
        let that = this;
        let res = await unmanApi.getWarehouseLocation()
        if(res.meta.code == 200){
          that.subList = res.data
        }else{
          showToast(res.meta.message)
        }
      },
      //获取预约记录列表
      async getAppointment(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          'sender_phone': that.keyword.phone,//手机号
          'boundOrder': that.keyword.order_id,//订单号
          'order_state': that.keyword.type,//类型
        }
        let res = await unmanApi.warehouseAppointment(data)
        if(res.meta.code == 200){
          that.recordList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getAppointment(val);
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
.CAppointmentRecord{
  .dib{
    display:inline-block;
  }
  .el-table__expanded-cell{
    background: #f2f2f2;
    .bgTable{
      background: #f2f2f2;
    }
    &:hover{
      background-color: #f2f2f2 !important;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td{
      background-color: #f2f2f2;
    }
  }
  .contDio{
    .el-select{ display:block;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CUnmanWarehouse/CAppointmentRecord.vue